/* Created by:Upendram Reddy Tanuja
Created on: 19-Sep-2019 11:30 AM
Purpose: To  save resume*/

import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ResumeBankService } from '../../../services/resume-referral/resume-referral.service';
import { ActivatedRoute } from '@angular/router';
import { FileDetails } from '../../../classes/resume/file-details';
import { ReferDetails } from '../../../classes/resume/refer-details';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MessageService } from 'src/app/services/message/message.service';

@Component({
  selector: 'app-resume-referral-details',
  templateUrl: './resume-referral-details.component.html',
  styleUrls: ['./resume-referral-details.component.scss'],
  providers: [ResumeBankService]
})
export class ResumeReferralDetailsComponent implements OnInit {
  resume_referral: UntypedFormGroup;
  isd = [];
  resume_details = new ReferDetails();
  search: string;
  public loading = 0;
  resume_ref_display;
  init() {
    this.resume_details = new ReferDetails();
    this.resume_referral = new UntypedFormGroup(
      {
        first_name: new UntypedFormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(100)]),
        last_name: new UntypedFormControl(''),
        mobile_no: new UntypedFormControl('', [Validators.required, Validators.min(1000000000), Validators.max(9999999999)]),
        mobile_no_cc: new UntypedFormControl(''),
        email_id: new UntypedFormControl('', [Validators.required, Validators.pattern(/^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-z]{2,4}|[0-9]{1,3})(\]?)$/)]),
      }
    );

  }
  constructor(public dialogRef: MatDialogRef<ResumeReferralDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private resume_serivce: ResumeBankService,
    private activated_route: ActivatedRoute,
    private snackbar: MatSnackBar,
    private message_service: MessageService) { }
  @Input() requisition_id;
  ngOnInit() {

    this.init();
    this.resume_serivce.getResume().subscribe(res => {

      if (res['data']) {
        this.resume_ref_display = true;
        this.isd = res['data'].isd;
        this.resume_referral.controls.mobile_no_cc.setValue(1000);

      }
    },
      err => {
        if (this.message_service.storage === 401) {
          this.snackbar.open('Unauthorized');
          this.dialogRef.close(null);
        }
      })
  }
  cancel() {
    this.dialogRef.close();
  }
  public file_doc: any;
  saveFileResult(ev, ) {
    this.resume_details.resume_document = (ev.files[0]);
    if (this.resume_details && (!this.resume_details.resume_document || !this.resume_details.resume_document['file_title'])) {
      setTimeout(function () {
        let shand = document.getElementsByClassName('document') as HTMLCollectionOf<HTMLElement>;
        if (shand.length != 0) {
          shand[0].style.color = 'red';
        }
      });

    }

    let base64 = (ev.files[0].content);
    let file_title = (ev.files[0].file_title);
    let mime_type = (ev.files[0].mime_type);
    function dataURLtoFile(dataurl, filename) {
      if (dataurl) {
        var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
      }
    }
    let file = dataURLtoFile(base64, file_title);
    this.file_doc = file;
    if (this.resume_details.resume_document && this.resume_details.resume_document['file_title']) {
      setTimeout(function () {
        let shand = document.getElementsByClassName('document') as HTMLCollectionOf<HTMLElement>;
        if (shand.length != 0) {
          shand[0].style.color = 'rgb(138, 138, 138)';
        }
      });
      this.saveFile();
    }
  }

  save() {
    if (this.resume_referral.valid && this.resume_details.resume_document && this.resume_details.resume_document['file_title']) {
      this.loading = 1;
      this.resume_details.setFormGroupData(this.resume_referral.value);

      this.resume_serivce.saveDetails(this.requisition_id, this.resume_details).subscribe(res => {

        if (res['data']) {
          this.snackbar.open(res['message']);
          this.dialogRef.close();
        }
        else {
          this.snackbar.open(res['message']);
        }
        this.loading = 0;

      },
        err => {
          this.loading = 0;
          if (this.message_service.storage === 401) {
            this.snackbar.open('Unauthorized');
            this.dialogRef.close(null);
          }
        })
    }
    else if (!this.resume_details.resume_document || !this.resume_details.resume_document['file_title']) {
      this.snackbar.open('Please upload your resume');
      // document.getElementsByClassName('document').
      setTimeout(function () {
        let shand = document.getElementsByClassName('document') as HTMLCollectionOf<HTMLElement>;
        if (shand.length != 0) {
          shand[0].style.color = 'red';
        }
      });
    }
    else {
      setTimeout(function () {
        let shand = document.getElementsByClassName('document') as HTMLCollectionOf<HTMLElement>;
        if (shand.length != 0) {
          shand[0].style.color = 'rgb(138, 138, 138)';
        }
      });
      this.snackbar.open('Please fill all the required fields')
    }
  }
  inputTextMaxNull(event: KeyboardEvent) {
    var input = <HTMLInputElement>event.srcElement;
    let charCode = (event.which) ? event.which : event.keyCode;
    try {
      if (charCode == 8 || charCode == 9) {
        return true;
      }
      if (input.value.length === 0 && event.keyCode === 32) {
        return false;
      }
      if ((charCode > 64 && charCode < 91) || event.keyCode === 32) {
        return true;
      }
      else {
        return false;
      }
    }
    catch (error) {

    }
  }
  inputText(event: KeyboardEvent, max) {
    var input = <HTMLInputElement>event.srcElement;
    let charCode = (event.which) ? event.which : event.keyCode;
    try {
      if (charCode == 8 || charCode == 9) {
        return true;
      }
      if (input.value.length === 0 && event.keyCode === 32 || input.value.length >= max) {
        return false;
      }
      if ((charCode > 64 && charCode < 91) || event.keyCode === 32) {
        return true;
      }
      else {
        return false;
      }
    }
    catch (error) {

    }
  }
  inputNumber(evt: KeyboardEvent) {
    let input = <HTMLInputElement>event.srcElement;
    let charCode = (evt.which) ? evt.which : evt.keyCode;
    try {
      if (charCode == 13) {
        return false;
      }
      if (charCode == 8 || charCode == 9) {
        return true;
      }
      if (input.value.length == 0) {
        if (charCode == 96 || charCode == 48) {
          return false
        }
        else if (charCode < 31 || (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
          return true;
        }
        else {
          return false;
        }
      }
      else if (input.value.length >= this.mobile_number_length) {
        return false;
      }
      else if (input.value.length < this.mobile_number_length) {
        if (charCode < 31 || (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
          return true;
        }
        else {
          return false;
        }
      }

    }
    catch (error) {

    }
  }
  mobile_number_length = 10;
  min_value;
  max_value;
  mobileLength(e) {
    try {
      if (e && this.isd && this.isd.length) {
        for (let i = 0; i < this.isd.length; i++) {
          if (e == this.isd[i].isd_code) {
            if (this.isd[i].mobile_number_length) {
              this.mobile_number_length = this.isd[i].mobile_number_length;
            }
          }
        }
        this.min_value = '1';
        this.max_value = '9';
        for (let i = 0; i < this.mobile_number_length - 1; i++) {
          this.min_value = this.min_value + '0';
        }
        for (let i = 0; i < this.mobile_number_length - 1; i++) {
          this.max_value = this.max_value + '9';
        }
        this.resume_referral.controls.mobile_no.setValidators([Validators.required, Validators.min(parseInt(this.min_value)), Validators.max(parseInt(this.max_value))]);
      }
    }
    catch (error) {

    }
  }
  // inputNumberOrDecimal(event: KeyboardEvent) {
  //   let input = <HTMLInputElement>event.srcElement;
  //   let charCode = (event.which) ? event.which : event.keyCode;
  //
  //   try {
  //     if (input.value.length == 0) {
  //       if (charCode == 110) {
  //         return false
  //       }
  //       else if (charCode < 31 || (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
  //         return true;
  //       }
  //       else {
  //         return false;
  //       }
  //     }
  //     else {
  //       if (charCode < 31 || (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105) || charCode == 110 || charCode == 190) {
  //         return true;
  //       }
  //       else {
  //         return false;
  //       }
  //     }
  //   }
  //   catch (error) {
  //
  //   }
  // }
  inputEmail(event: KeyboardEvent) {
    let input = <HTMLInputElement>event.srcElement;
    let charCode = (event.which) ? event.which : event.keyCode;

    if (charCode === 20) {
      return false;
    }
    try {
      if (event.keyCode === 32) {
        return false;
      }
    }
    catch (error) {

    }
  }
  selected_obj(e) {
    try {
      if (e && e.isd_code) {
        this.mobileLength(e.isd_code);
      }
    }
    catch (e) {

    }
  }
  saveFile() {
    let input = new FormData();
    // Add your values in here
    if (this.file_doc && this.file_doc.name) {
      input.append('attachment', this.file_doc, this.file_doc.name);
      this.resume_serivce.saveFile(input).subscribe(res => {

        this.resume_details.setFile(res['Document']);
        this.resume_referral.setValue(this.resume_details.getFormGroupData());
      })
    }
  }
}
